import React from 'react';
import PropTypes from 'prop-types';
import { Toggle } from '@one-thd/sui-atomic-components';
import { InStorePopover } from '../InStoreRefinmentPopover';
import { NearbyStores } from '../../StoreSelector/NearbyStores';

export const InNearbyStoreMobile = ({
  isNearbyStores,
  onNearbyStoresToggle,
  storeSearch,
  multiStoreSelection,
  onMultiStoreSelectionChange,
  setIsNearbyStores
}) => {
  return (
    <div className="sui-flex sui-mt-3" data-testid="in-nearby-store-mobile">
      <Toggle
        inputAttributes={{ 'aria-label': 'In Store' }}
        checked={isNearbyStores}
        onChange={onNearbyStoresToggle}
      />
      <InStorePopover
        isVisible={isNearbyStores}
        text="Include"
        linkText="nearby stores"
        popoverContent={(
          <NearbyStores
            stores={storeSearch}
            multiStoreCallback={onMultiStoreSelectionChange}
            multiStoreSelection={multiStoreSelection}
            setNearbyStores={setIsNearbyStores}
          />
        )}
      />
    </div>
  );

};

InNearbyStoreMobile.propTypes = {
  isNearbyStores: PropTypes.bool.isRequired,
  onNearbyStoresToggle: PropTypes.func.isRequired,
  storeSearch: PropTypes.arrayOf(PropTypes.shape({
    storeId: PropTypes.string,
    storeName: PropTypes.string,
    phone: PropTypes.string,
    address: PropTypes.shape({
      postalCode: PropTypes.string
    })
  })),
  multiStoreSelection: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  onMultiStoreSelectionChange: PropTypes.func,
  setIsNearbyStores: PropTypes.func.isRequired
};

InNearbyStoreMobile.defaultProps = {
  storeSearch: [],
  multiStoreSelection: [],
  onMultiStoreSelectionChange: () => {}
};